import {color_green, color_grey} from "@/agentur/AgenturColors";
import Box from "@mui/material/Box";
import {Grid2, Typography} from "@mui/material";

import Divider from "@mui/material/Divider";
import React from "react";
import { compactValue } from "@/lib/screen-class";
import { LANDING_BODY_LARGE } from "@/pages/landing-page/utils/landing-font-sizes";

export interface InfoCardProps {
    nr: number;
    label: string;
    text: string;
    Svg: React.FunctionComponent;
    NrSvg: React.FunctionComponent<{ style: React.CSSProperties }>;
}

export const InfoCard = ({ nr, label, text, Svg, NrSvg }: InfoCardProps) => (
    <Box
        data-cy="info-card"
        sx={{
            backgroundColor: color_grey[5],
            borderRadius: 2,
            width: compactValue("100%", "341px"),
            maxWidth: "341px"
        }}
    >
        <Grid2 container direction="column" padding={compactValue(4, 8)} position="relative" height="340px">
            <NrSvg style={{ position: "absolute", top: 179, right: 60, zIndex: 0, transform: "translateZ(0)" }} />
            <Grid2>
                <Svg />
            </Grid2>
        </Grid2>
        <Grid2 padding={3}>
            <Typography sx={{ fontSize: LANDING_BODY_LARGE }} fontWeight="700" marginBottom={2}>
                {label} {nr}
            </Typography>
            <Divider dir="horizontal" color={color_green[2]} sx={{ borderWidth: "1.5px" }} />
        </Grid2>
        {/* From `md` the fixed height keeps cards in one row equally high; below `md` each card stands alone. */}
        <Grid2 px={3} sx={{ height: compactValue("auto", "8em"), paddingBottom: compactValue(3, 0) }}>
            <Typography sx={{ fontSize: LANDING_BODY_LARGE, maxWidth: "240px" }}>
                {text}
            </Typography>
        </Grid2>
    </Box>
);
